import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { IDocument } from 'app/models/documents/document';
import { Observable } from 'rxjs';
import { IDocumentType } from 'app/models/documents/documentType';

@Injectable({providedIn: 'root'})
export class DocumentService {
  public api: string = environment.privateApi + 'Document/'
  private http = inject(HttpClient);

  getDocumentTypes(types: string[]): Observable<IDocumentType[]>{
    return this.http.post<IDocumentType[]>(this.api + 'GetDocumentTypes', types);
  }

  getDocuments(entityId: number, entityType: string, includeArchived: boolean): Observable<IDocument[]>{
    return this.http.get<IDocument[]>(this.api + 'GetDocuments/' + entityId + '/' + entityType + '/' + includeArchived);
  }

  uploadDocument(file: FormData, entityType: string): Observable<IDocument>{
    return this.http.post<IDocument>(this.api + 'UploadDocument/' + entityType, file)
  }

  uploadAzureDocument(document: IDocument, entityType: string): Observable<IDocument>{
    return this.http.post<IDocument>(this.api + 'UploadAzureDocument/' + entityType, document)
  }

  downloadDocument(documentId: number): Observable<Blob>{
    return this.http.get<Blob>(this.api + "DownloadDocument/" + documentId, { responseType: 'blob' as 'json' })
  }

  getReferenceDocument(documentType: string): Observable<Blob>{
    return this.http.get<Blob>(this.api + "GetReferenceDocument/" + documentType, { responseType: 'blob' as 'json' })
  }

  archiveDocument(documentId: number, archive: boolean): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'ArchiveDocument/' + documentId + '/' + archive, null);
  }

  deleteDocument(documentId: number): Observable<any>{
    return this.http.delete<any>(this.api + "DeleteDocument/" + documentId)
  }

  generateSASUrl(permission: string, fileName: string): Observable<string> {
    return this.http.get(this.api + "GenerateSASUrl/" + permission + '/' + fileName, { responseType: 'text' });
  }
}
